import { cn } from "@/lib/utils"

interface StatTileProps {
  value: React.ReactNode
  label: React.ReactNode
  icon?: React.ReactNode
  /** Пояснение (обычно InfoTooltip) — в фиксированном углу плашки, а не внутри label, чтобы не гулять вместе с переносом текста подписи. */
  tooltip?: React.ReactNode
  gradient?: string
  /** Однотонный текст вместо градиента — для сдержанной палитры, где акцент несёт не каждое число. */
  plain?: boolean
  size?: "sm" | "md"
  className?: string
}

/** Крупное число с подписью снизу (и опциональной иконкой сверху) — общий паттерн статистики в личном кабинете. */
export function StatTile({
  value,
  label,
  icon,
  tooltip,
  gradient = "from-cyan-400 to-blue-400",
  plain = false,
  size = "sm",
  className,
}: StatTileProps) {
  return (
    <div className={cn("relative min-w-0 text-center", className)}>
      {tooltip && <div className="absolute -top-0.5 right-0">{tooltip}</div>}
      {icon && <div className="mb-1.5 flex justify-center">{icon}</div>}
      {/* div, not p — value can be a Skeleton (renders a div), which isn't valid inside a p */}
      <div
        className={cn(
          "font-bold",
          size === "md" ? "text-2xl sm:text-3xl lg:text-4xl" : "text-xl sm:text-2xl lg:text-3xl",
          plain ? "text-gray-100" : cn("bg-gradient-to-r bg-clip-text text-transparent", gradient)
        )}
      >
        {value}
      </div>
      <div lang="ru" style={{ hyphens: "auto" }} className="text-gray-400 text-[11px] sm:text-xs mt-1 leading-tight">
        {label}
      </div>
    </div>
  )
}
